// extracted by mini-css-extract-plugin
module.exports = {"regionName":"style_regionName__3_NSL","nodeList":"style_nodeList__2sJxz","width100":"style_width100__IjJ-e"};